import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
export var ThumbnailButtonImageViewer = function ThumbnailButtonImageViewer(_ref) {
  var file = _ref.file,
      onDelete = _ref.onDelete;
  var imageRef = useRef(null);
  var isDragging = useRef(false);
  var startX = useRef(0);
  var startY = useRef(0);
  var offsetX = useRef(0);
  var offsetY = useRef(0);

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      scale = _useState2[0],
      setScale = _useState2[1];

  var _useState3 = useState('grab'),
      _useState4 = _slicedToArray(_useState3, 2),
      grabStyle = _useState4[0],
      setGrabStyle = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFullscreen = _useState6[0],
      setIsFullscreen = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isPdf = _useState8[0],
      setIsPdf = _useState8[1];

  var _useState9 = useState({
    x: 0,
    y: 0
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      translate = _useState10[0],
      setTranslate = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      src = _useState12[0],
      setSrc = _useState12[1];

  var fileName = file.name;

  var showImage = function showImage(image) {
    var isPDFFile = file.type === 'application/pdf';
    setIsPdf(isPDFFile);
    var reader = new FileReader();

    reader.onload = function (e) {
      var target = e.target;

      if (target.result) {
        setSrc(target.result);
      }
    };

    if (isPDFFile) {
      setSrc(URL.createObjectURL(image));
    } else {
      reader.readAsDataURL(image);
    }
  };

  useEffect(function () {
    showImage(file);
  }, []);

  var toggleFullscreen = function toggleFullscreen() {
    setIsFullscreen(function (prev) {
      return !prev;
    });
    setTranslate({
      x: 0,
      y: 0
    });
    setScale(1);
  };

  var handleThumbnailClick = function handleThumbnailClick() {
    if (isPdf && src) {
      // Open PDF in new tab
      window.open(src, '_blank');
    } else {
      // Toggle fullscreen for images
      toggleFullscreen();
    }
  };

  var zoomIn = function zoomIn() {
    return setScale(function (prev) {
      return Math.min(prev + 0.2, 3);
    });
  };

  var zoomOut = function zoomOut() {
    return setScale(function (prev) {
      return Math.max(prev - 0.2, 0.5);
    });
  };

  var handleDragStart = function handleDragStart(e) {
    setGrabStyle('grabbing');
    e.preventDefault();
    isDragging.current = true;
    var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
    startX.current = clientX - offsetX.current;
    startY.current = clientY - offsetY.current;
  };

  var handleDragMove = function handleDragMove(e) {
    if (!isDragging.current) return;
    e.preventDefault();
    var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
    var dx = clientX - startX.current;
    var dy = clientY - startY.current;
    offsetX.current = dx;
    offsetY.current = dy;
    setTranslate({
      x: dx,
      y: dy
    });
  };

  var handleDragEnd = function handleDragEnd() {
    setGrabStyle('grab');
    isDragging.current = false;
  };

  return React.createElement("div", null, isFullscreen && React.createElement("div", {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9998,
      touchAction: 'none'
    }
  }, isPdf ? React.createElement("embed", {
    src: src,
    type: "application/pdf",
    width: "90%",
    height: "90%",
    style: {
      transform: "scale(".concat(scale, ")"),
      transition: 'transform 0.2s ease'
    }
  }) : React.createElement("img", {
    ref: imageRef,
    src: src,
    alt: "Fullscreen",
    style: {
      cursor: grabStyle,
      width: "".concat(scale * 90, "vw"),
      maxWidth: '100%',
      transform: "scale(".concat(scale, ") translate(").concat(translate.x, "px, ").concat(translate.y, "px)"),
      transition: 'transform 0.2s ease'
    },
    onMouseDown: handleDragStart,
    onMouseMove: handleDragMove,
    onMouseUp: handleDragEnd,
    onMouseLeave: handleDragEnd,
    onTouchStart: handleDragStart,
    onTouchMove: handleDragMove,
    onTouchEnd: handleDragEnd
  }), React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      padding: '10px',
      borderRadius: '10px',
      zIndex: 9999
    }
  }, React.createElement("button", {
    onClick: zoomOut,
    style: {
      padding: '10px 15px',
      fontSize: '16px',
      cursor: 'pointer',
      backgroundColor: 'var(--red)',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      userSelect: 'none'
    }
  }, React.createElement("i", {
    className: "fas fa-search-minus"
  }), " Zoom Out"), React.createElement("button", {
    onClick: zoomIn,
    style: {
      padding: '10px 15px',
      fontSize: '16px',
      cursor: 'pointer',
      backgroundColor: 'var(--teal)',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      userSelect: 'none'
    }
  }, React.createElement("i", {
    className: "fas fa-search-plus"
  }), " Zoom In"), React.createElement("button", {
    onClick: toggleFullscreen,
    style: {
      padding: '10px 15px',
      fontSize: '16px',
      cursor: 'pointer',
      backgroundColor: 'var(--red)',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      userSelect: 'none'
    }
  }, "Exit Fullscreen"))), src && React.createElement("div", {
    className: "thumbnail"
  }, React.createElement("button", {
    onClick: handleThumbnailClick,
    type: "button"
  }, React.createElement("div", null, isPdf ? React.createElement(React.Fragment, null, React.createElement("i", {
    className: "fas fa-file-pdf",
    style: {
      color: 'var(--teal)'
    }
  })) : React.createElement("img", {
    src: src,
    alt: "Thumbnail"
  }), React.createElement("span", null, fileName))), React.createElement("button", {
    type: "button",
    onClick: onDelete,
    "aria-label": "Remove document"
  }, React.createElement("i", {
    className: "fas fa-times"
  }))));
};
export default ThumbnailButtonImageViewer;